import { CollectionSlug } from 'payload'
import { CreateCollectionConfigProps } from '@utils/collections'

export type CascadeDeleteProps = {
  collection: CollectionSlug;
  on?: string;
}

export const enableCascadeDelete = (collection: CreateCollectionConfigProps, cascadeDeletes: CascadeDeleteProps[]): CreateCollectionConfigProps => {
  collection.hooks = collection.hooks || {};
  collection.hooks.beforeDelete = collection.hooks.beforeDelete || [];
  collection.hooks.beforeDelete.unshift(async (args) => {
    const { req, id } = args;

    // Check if there is a transaction
    if (! req.transactionID) {
      console.error('[CascadeDelete] It\'s not safe to proceed without a transaction.');
      return;
    }

    for (let i = 0; i < cascadeDeletes.length; i++) {
      const { collection: onDeleteCollection, on } = cascadeDeletes[i];
      const column = on ?? collection.slug;

      const { errors } = await req.payload.delete({
        collection: onDeleteCollection,
        where: { [column]: { equals: id } },
        req,
      });

      // With errors, throw the first one
      if (errors && errors.length > 0) {
        throw new Error( errors[0].message || 'Erro ao excluir um dos itens relacionados.' );
      }
    }
  });

  return collection;
}
